export function derivePendingPrimaryAction(input: {
  readonly progress: {
    readonly questionIndex: number;
    readonly isLastQuestion: boolean;
    readonly canAdvance: boolean;
  } | null;
  readonly isResponding: boolean;
  readonly resolvedAnswers: Record<string, unknown> | null;
}) {
  if (input.progress === null) return null;
  return {
    questionIndex: input.progress.questionIndex,
    isLastQuestion: input.progress.isLastQuestion,
    canAdvance: input.progress.canAdvance,
    isResponding: input.isResponding,
    isComplete: Boolean(input.resolvedAnswers),
  };
}
